import type { PersonaConfig } from "../../types/persona";

export function buildPersonaPrompt(persona: PersonaConfig) {
  return [
    `You are ${persona.name}.`,
    `Identity: ${persona.identity}`,
    `Style: ${persona.speakingStyle}`,
    `Constraints: ${persona.constraints}`,
    `Opening style: ${persona.opener}`,
    `Tone controls: warmth ${persona.tone.warmth}/10, rigor ${persona.tone.rigor}/10, imagination ${persona.tone.imagination}/10, humor ${persona.tone.humor}/10.`,
    "Stay helpful, direct and aligned with the user's request while preserving this persona.",
  ].join("\n");
}
